import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Loader from '../components/Loader';
import { Button } from '../components/styles/Button';
import { getUpdates, deleteUpdate } from '../services/updateService';
import { CardStyles } from '../components/styles/CardStyles';
import Pagination from '../components/Pagination';
import ReusableModal from '../components/ReusableModal';
import { InternalLinkButtonStyles } from '../components/styles/InternalLinkButtonStyles';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 80%;

  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

const UpdateName = styled.h3`
  flex: 3;
`;

const VersionNumber = styled.p`
  flex: 2;
`;

const DetailsButton = styled(InternalLinkButtonStyles)`
  flex: 1;
`;

export default function UpdatesPage() {
  const [loading, setLoading] = useState(true);
  const [updates, setUpdates] = useState([]);
  const [count, setCount] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateToBeDeleted, setUpdateToBeDeleted] = useState(null);

  useEffect(() => {
    setLoading(true);
    getUpdates(currentPage, limit)
      .then((response) => {
        setLoading(false);
        if (response.status === 200) {
          setUpdates(response.body.updates);
          setCount(response.body.count);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [currentPage, limit]);

  function openDeletionModal(updateId) {
    setUpdateToBeDeleted(updateId);
    setIsModalOpen(true);
  }

  function closeDeletionModal() {
    setUpdateToBeDeleted(null);
    setIsModalOpen(false);
  }

  function handleDelete() {
    deleteUpdate(updateToBeDeleted)
      .then((res) => {
        if (res.status === 200) {
          const updatedList = updates.filter(
            (update) => update._id !== updateToBeDeleted
          );
          setUpdates(updatedList);
          toast.success(`Update successfully deleted`);
          setIsModalOpen(false);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <>
      <Layout>
        <Pagination
          totalItems={count}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          limit={limit}
          setLimit={setLimit}
        />
        {loading && <Loader />}
        <Wrapper>
          {!updates?.length && !loading && <h1>No updates was found.</h1>}
          {!loading &&
            updates?.length > 0 &&
            updates.map((update) => (
              <CardStyles key={update._id}>
                <UpdateName>{update.name}</UpdateName>
                <VersionNumber>{update.version}</VersionNumber>
                <DetailsButton to={`/update/${update._id}`}>
                  Details
                </DetailsButton>
                <Button
                  onClick={() => openDeletionModal(update._id)}
                  style={{ flex: 1, alignSelf: 'flex-end' }}
                >
                  DELETE
                </Button>
              </CardStyles>
            ))}
        </Wrapper>
      </Layout>
      <ReusableModal isOpen={isModalOpen} close={closeDeletionModal}>
        <p>Do you really want to delete this update?</p>
        <div style={{ display: 'flex', marginTop: '1rem', gap: '1rem' }}>
          <Button
            onClick={closeDeletionModal}
            style={{
              border: '1px solid hsl(var(--color-primary))',
              backgroundColor: 'var(--color-white)',
              color: 'hsl(var(--color-primary))',
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            style={{ border: '1px solid hsl(var(--color-primary))' }}
          >
            Delete
          </Button>
        </div>
      </ReusableModal>
    </>
  );
}
